//
// Reward tags
//
export default [
  'products', 'favors', 'screentime', 'trips',
  'money', 'snacks',
  'children', 'teenagers', 'adults',
];
